export const DEFAULT_CHAT_PANEL_WIDTH = 420;
export const MIN_CHAT_PANEL_WIDTH = 340;
export const MAX_CHAT_PANEL_WIDTH = 640;
